// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cardVavaka {
  position: relative;
  background: white;
  width: 350px;
  height: 30vh;
  border-radius: 5px;
  padding: 10px;
  margin: 20px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.cardVavaka img {
  position: absolute;
  top: 5px;
  right: 10px;
  width: 50px;
}
.cardVavaka .lohateny {
  color: #0c172b;
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  margin: 0;
  text-align: center;
}
.cardVavaka .vavaka {
  color: #222;
  font-size: 16px;
  font-family: "Times New Roman", Times, serif;
  margin: 0;
  text-align: justify;
  background: none;
}
.cardVavaka .buttonContainer {
  position: absolute;
  display: flex;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
.cardVavaka .buttonContainer button {
  background-color: #bf9e1d;
  color: white;
  font-size: 21px;
  border: none;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px;
}
.cardVavaka .buttonContainer {
  /* Réduire l'opacité au survol du bouton */
}
.cardVavaka .buttonContainer:hover button {
  opacity: 1;
}
.cardVavaka {
  /* Afficher les boutons au survol */
}
.cardVavaka:hover .buttonContainer {
  opacity: 1;
  visibility: visible;
}

.cardVavaka:hover {
  background: #282881;
}
.cardVavaka:hover .lohateny, .cardVavaka:hover .vavaka {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/CardVavaka/cardVavaka.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;AAEF;AAAE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAEJ;AACE;EACE,cAAA;EACA,eAAA;EACA,4CAAA;EACA,SAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;EACA,eAAA;EACA,4CAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,mDAAA;AADJ;AAGI;EAEE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFN;AAlBE;EAuBE,0CAAA;AAFJ;AAGI;EACE,UAAA;AADN;AA9DA;EAmEE,mCAAA;AAFF;AAGE;EACE,UAAA;EACA,mBAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;AAIE;EACE,WAAA;AAFJ","sourcesContent":[".cardVavaka {\n  position: relative;\n  background: white;\n  width: 350px;\n  height: 30vh;\n  border-radius: 5px;\n  padding: 10px;\n  margin: 20px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; \n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n  img {\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    width: 50px;\n  }\n\n  .lohateny{\n    color: #0c172b;\n    font-size: 25px;\n    font-family: \"Times New Roman\", Times, serif;\n    margin: 0;\n    text-align: center;\n  }\n\n  .vavaka{\n    color: #222;\n    font-size: 16px;\n    font-family: \"Times New Roman\", Times, serif;\n    margin: 0;\n    text-align: justify;\n    background: none;\n  }\n\n  .buttonContainer {\n    position: absolute;\n    display: flex;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n\n    button {\n      // opacity: 0.7;\n      background-color: #bf9e1d;\n      color: white;\n      font-size: 21px;\n      border: none;\n      padding: 10px;\n      border-radius: 50%;\n      cursor: pointer;\n      transition: opacity 0.3s ease;\n      display: flex; \n      align-items: center;\n      justify-content: center;\n      margin: 30px;\n    }\n\n    /* Réduire l'opacité au survol du bouton */\n    &:hover button {\n      opacity: 1;\n    }\n  }\n\n  /* Afficher les boutons au survol */\n  &:hover .buttonContainer {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.cardVavaka:hover {\n  background: #282881;\n\n  .lohateny, .vavaka{\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
